'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSigning$002dPage from "./presto.-Signing-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_SigningPage$() {
}
export { $c_Lpresto_SigningPage$ as $c_Lpresto_SigningPage$ };
$p = $c_Lpresto_SigningPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SigningPage$;
/** @constructor */
function $h_Lpresto_SigningPage$() {
}
export { $h_Lpresto_SigningPage$ as $h_Lpresto_SigningPage$ };
$h_Lpresto_SigningPage$.prototype = $p;
$p.l = (function() {
  return "SigningPage";
});
$p.cGh = (function(x$0) {
  return new $j_presto$002e$002dSigning$002dPage.$c_Lpresto_SigningPage(x$0.j(0));
});
var $d_Lpresto_SigningPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SigningPage$, "presto.SigningPage$", ({
  QM: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_SigningPage$ as $d_Lpresto_SigningPage$ };
var $n_Lpresto_SigningPage$;
function $m_Lpresto_SigningPage$() {
  if ((!$n_Lpresto_SigningPage$)) {
    $n_Lpresto_SigningPage$ = new $c_Lpresto_SigningPage$();
  }
  return $n_Lpresto_SigningPage$;
}
export { $m_Lpresto_SigningPage$ as $m_Lpresto_SigningPage$ };
//# sourceMappingURL=presto.-Signing-Page$.js.map
